import { render, staticRenderFns } from "./answerArea.vue?vue&type=template&id=f22dac1e&"
import script from "./answerArea.vue?vue&type=script&lang=js&"
export * from "./answerArea.vue?vue&type=script&lang=js&"
import style0 from "./answerArea.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports